import userTypes from '~/modules/user/types';
import installationTypes from './types';
import {updateUser, remove, create} from './actions';

const success = (fn) => (action, ...args) => {
  if (action.pending || action.error) {
    return null;
  }

  return fn(action, ...args);
};


export default {
  [userTypes.USER_DATA]: [
    success((action, store) => updateUser(store.getState().user.token)),
  ],
  [userTypes.LOGOUT]: [
    success(remove),
  ],
  [installationTypes.INSTALLATION_CREATED]: [
    success((action, store) => {
      const token = store.getState().user.token;
      return token && updateUser(token);
    }),
  ],
  [installationTypes.INSTALLATION_REMOVED]: [
    success(create),
  ],
};



// WEBPACK FOOTER //
// ./src/modules/installation/reactions.js